import React from 'react'

export default function InfoCircleIcon() {
    return (
        <svg className='info-circle' xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 19 18">
            <path className='info' d="M10.8 7.77v5.5H8.97v-5.5h1.85Zm-.92-3.05c.21 0 .4.05.58.16.17.1.31.23.42.4.1.17.14.37.14.6 0 .3-.1.57-.32.79-.23.22-.5.33-.82.33-.32 0-.59-.11-.81-.33a1.06 1.06 0 0 1-.34-.8 1.11 1.11 0 0 1 .58-1c.16-.1.36-.15.57-.15Z"/>
            <path className='circle' d="M1.97 9a7.9 7.9 0 1 0 7.9-7.9V0a9 9 0 1 1 0 18 9 9 0 0 1 0-18v1.1A7.9 7.9 0 0 0 1.98 9Z"/>
        </svg>
    )
}